import { COMPONENT_SETTING_TYPES, COMPONENT_DSL_NAMES, COMPONENT_SETTING_VIEWS, } from '../../../constants';
import { BASIC_STYLE_TOOLTIP, BASIC_PROPS_TOOLTIP, getBasicPropsSettings, NS_ID, } from '../../common';
import { getDivider, getEventsSection, getPropertySections, getStyleSections, } from '../../common/settings';
import { getCommonAccordionActionsSettings } from '../../material-components/MaterialAccordionActions/MaterialAccordionActions.settings';
import { getCommonAccordionDetailsSettings } from '../../material-components/MaterialAccordionDetails/MaterialAccordionDetails.settings';
import { getCommonAccordionSummarySettings } from '../../material-components/MaterialAccordionSummary/MaterialAccordionSummary.settings';
export const AccordionSymbolSettings = {
    properties: [
        {
            type: COMPONENT_SETTING_TYPES.rootSection,
            name: NS_ID.properties.root,
            children: [
                {
                    type: COMPONENT_SETTING_TYPES.section,
                    title: 'Basic',
                    name: NS_ID.properties.basic,
                    titleDescription: BASIC_PROPS_TOOLTIP,
                    children: [
                        {
                            type: COMPONENT_SETTING_TYPES.node,
                            name: 'summary',
                            label: 'Summary',
                            keyPath: ['summary'],
                            required: true,
                            items: [
                                {
                                    name: COMPONENT_DSL_NAMES.MaterialAccordionSummary,
                                    settings: getCommonAccordionSummarySettings(),
                                },
                            ],
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.node,
                            name: 'details',
                            label: 'Details',
                            keyPath: ['details'],
                            required: true,
                            items: [
                                {
                                    name: COMPONENT_DSL_NAMES.MaterialAccordionDetails,
                                    settings: getCommonAccordionDetailsSettings(),
                                },
                            ],
                        },
                        {
                            type: COMPONENT_SETTING_TYPES.node,
                            name: 'actions',
                            label: 'Actions',
                            keyPath: ['actions'],
                            items: [
                                {
                                    name: COMPONENT_DSL_NAMES.MaterialAccordionActions,
                                    settings: getCommonAccordionActionsSettings(),
                                },
                            ],
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: ['disabled'],
                            label: 'Disabled',
                        },
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: ['expanded'],
                            label: 'Expanded',
                        },
                    ],
                },
                getDivider(),
                ...getBasicPropsSettings(),
                getDivider(),
                ...getPropertySections(),
            ],
        },
    ],
    style: [
        {
            type: COMPONENT_SETTING_TYPES.rootSection,
            name: NS_ID.style.root,
            children: [
                {
                    type: COMPONENT_SETTING_TYPES.section,
                    title: 'Basic',
                    name: NS_ID.style.basic,
                    titleDescription: BASIC_STYLE_TOOLTIP,
                    children: [
                        {
                            componentView: COMPONENT_SETTING_VIEWS.checkbox,
                            type: COMPONENT_SETTING_TYPES.prop,
                            keyPath: ['square'],
                            label: 'Square',
                        },
                    ],
                },
                getDivider(),
                ...getStyleSections(),
            ],
        },
    ],
    events: [
        {
            type: COMPONENT_SETTING_TYPES.rootSection,
            name: NS_ID.events.root,
            children: getEventsSection(),
        },
    ],
};
